var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9934 24.2998L20.0534 29.2398C17.3134 31.9798 17.3134 36.3998 20.0534 39.1398C22.7934 41.8798 27.2134 41.8798 29.9534 39.1398L37.7334 31.3598C43.1934 25.8998 43.1934 17.0198 37.7334 11.5598C32.2734 6.09984 23.3934 6.09984 17.9334 11.5598L9.45336 20.0398C4.77336 24.7198 4.77336 32.3198 9.45336 37.0198",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip2);
export default __webpack_public_path__ + "static/media/paperclip-2.6facb5485afd9eea95b3825187d07f76.svg";
export { ForwardRef as ReactComponent };